<template>
  <div class="coal-buttom">
    <div class="coal-list">
      <span
        :class="l == i ? 'a' : 'span'"
        v-for="(item, i) in list"
        :key="i"
        @click="item1(i)"
        >{{ item }}</span
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      l: 0,
      list: ["煤矿主场景", "采煤工作面", "掘进工作面"],
    };
  },
  methods: {
    item1(a) {
      this.l = a;
    },
  },
};
</script>
<style lang="less" scoped>
.coal-buttom {
  width: 60%;
  height: 7%;
  position: absolute;
  bottom: 25%;
  left: 20%;
  background-image: url("../../assets/bottm.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .coal-list {
    width: 50%;
    height: 20%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 0.2vh;
    .span {
      display: block;
      width: 6vw;
      height: 5vh;
      text-align: center;
      line-height: 5vh;
      font-weight: 900;
      font-size: 0.1vw;
      color: rgb(156, 200, 255);
      cursor: pointer;
    }
  }
}
.a {
  display: block;
  width: 6vw;
  height: 5vh;
  text-align: center;
  line-height: 5vh;
  font-weight: 900;
  font-size: 0.5vw;
  background-image: url(../../assets/backimg.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position-y: center;
  color: #fff;
  cursor: pointer;
}
</style>